// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__RJUCe","container":"footer_container__pbeLT","copyright":"footer_copyright__99CuL","divider":"footer_divider__JygrD","logo":"footer_logo__vkH-H"};